export const CUSTOMER_CREATE_CHANGE_TRACKING = {
  nameAndAddress: {
    source: 'customer_create.name_and_address',
    id: 24001,
  },
  contacts: {
    source: 'customer_create.contacts',
    id: 24002,
  },
  uploadCreditInformation: {
    source: 'customer_create.upload_credit_information',
    id: 24003,
  },
  ownership: {
    source: 'customer_create.ownership',
    id: 24004,
  },
} as const;
